<div class="prescription-main">
  <div class="prescription-area" (click)="$event.stopPropagation()">
    <div class="prescription-area-top">
      <h2>Prescriptions</h2>
      <div class="cross-icon" (click)="onNoClick()">
        <i class="fa-solid fa-xmark"></i>
      </div>
    </div>
    <div class="prescription-bottom-area">
      <div class="prescription-dropdown">
        <button
          type="button"
          (click)="onShowHideDropdown()"
          [class.active]="showHideDropdown"
        >
          <span>কেন প্রেসক্রিপশনের ছবি আপলোড করবেন?</span>
          <small><i class="fa-solid fa-chevron-down"></i></small>
        </button>
        <div class="dropdown-data" *ngIf="showHideDropdown">
          <ul>
            <li>
              প্রেসক্রিপশন হারানোর ভয় থেকে আপনি মুক্ত, আজীবনের জন্য মেডিসিনডিপো
              এপে আপনি খুজে পাবেন আপনার ডিজিটাল প্রেসক্রিপশন।
            </li>
            <li>
              ডাক্তারের হাতের লেখা বুঝা না গেলেও কোন সমস্যা নেই, আমাদের 'A'
              গ্রেড ফার্মাসিস্ট প্রেস্ক্রিপশন দেখে ঔষধ অর্ডারে আপনাকে সহযোগিতা
              করবে।
            </li>
            <li>
              আপনার প্রেসক্রিপশন কখনো তৃতীয় কোন পক্ষের সাথে শেয়ার করা হবে না।
            </li>
            <li>
              বাংলাদেশ সরকারের নিয়ম অনুসারে, কিছু মেডিসিন অর্ডার করার জন্য
              প্রেসক্রিপশন থাকা বাধ্যতামুলক।
            </li>
          </ul>
        </div>
      </div>
      <div class="upload-prescription-main">
        <app-drop-zone (newItemEvent)="onGetImageData($event)"></app-drop-zone>

        <form #formElement="ngForm" [formGroup]="dataForm">
          <div class="form-input1 input-data" *ngIf="this.files">
            <mat-form-field appearance="outline" class="field m-100" >
              <mat-label>আপনার ঔষধ এর বিবরণ ও প্ৰয়োজনীয় সংখ্যা লিখুন </mat-label>
              <textarea matInput  rows="3" formControlName="description"></textarea>
              <mat-error>This Field is Required</mat-error>
            </mat-form-field>
          </div>
        </form>

        <div class="upload-prescription-button">
          <div
            style="
              display: flex;
              align-items: center;
              gap: 10px;
              justify-content: space-between;
            "
            class="res-d"
          >
            <a (click)="onShowPrescriptionDemo()">
              <i class="fa-solid fa-circle-exclamation"></i>
              <span>Valid prescription guide</span>
            </a>
            <a
              (click)="openDialog()"
              style="
                background-color: #5aafed;
                border-radius: 5px;
                padding: 6px 10px;
              "
            >
              <span style="color: #fff">
                {{
                  address ? "Address Selected" : "Select Shipping Address"
                }}</span
              >
            </a>
          </div>

          <button type="button" (click)="onUploadImg()">
            <i class="fa-solid fa-print"></i>
            <span>Upload Prescription </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-demo-prescription #demo_prescription></app-demo-prescription>
